import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=5b6e8d32&scoped=true"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"
import style0 from "./PersonModal.vue?vue&type=style&index=0&id=5b6e8d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e8d32",
  null
  
)

export default component.exports